import Row from './src/row';

/* istanbul ignore next */
Row.install = function(Vue) {
  Vue.component(Row.name, Row);
};

export default Row;




// WEBPACK FOOTER //
// ./src/components/element/packages/row/index.js